import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Col, Row } from "react-bootstrap";
import requestUtil from "../../../helpers/requestUtil";
import useConfiguration from "../../../hooks/useConfiguration";
import useSessionStorage from "../../../hooks/useSessionStorage";
import { toast } from "react-toastify";
import moment from "moment";

const EmailReply = ({ showModal, closeModal, candidateUniqueId, data }) => {
    const [fileInputs, setFileInputs] = useState([]);
    const [subject, setSubject] = useState('')
    const config = useConfiguration();
    const storage = useSessionStorage();
    const login = storage.getItem("login");
    const [sessionId, setSessionId] = useState('');
    useEffect(() => {
        if (showModal) {
            window.enableSummerNote()
        }
    }, [showModal])
    const addFileInput = () => {
        setFileInputs([
            ...fileInputs,
            { id: Date.now(), file: null, fileName: "" },
        ]);
    };

    useEffect(() => {
        setSubject(data?.messageSubject)
    }, [data?.messageSubject])

    useEffect(() => {
        setSessionId(generate_uuidv4)
        return () => {
            setSessionId('')
        }
    }, [])

    const removeFileInput = async (id, canTrackId) => {
        const updatedInputs = fileInputs.filter((input) => input.id !== id);
        setFileInputs(updatedInputs);
        if (config.baseUrl && canTrackId) {
            await requestUtil(
                `${config.baseUrl}/Messaging/delete-candidates-files-tracking-document`,
                "DELETE",
                canTrackId
            );
        }
    };

    const fileDownloadUploadDoc = async (filename, docId, { url }) => {
        const queryString = docId
            .map((id) => `CandidateFileTrackingId=${id}`)
            .join("&");
        const requestHeaders = {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: login.accessToken ? `Bearer ${login.accessToken}` : "",
        };
        fetch(`${config.baseUrl}/${url}${queryString}`, {
            headers: requestHeaders,
        }).then((response) => {
            response.blob().then((blob) => {
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement("a");
                a.href = url;
                a.download = filename;
                a.click();
            });
        });
    };

    const fileChange = async (e, inputId) => {
        const file = e.target.files[0];
        const formdata = new FormData();
        formdata.append("File", file);
        formdata.append(
            "CandidateUniqueId", candidateUniqueId
        );
        formdata.append("EmployerUniqueId", login.employerUniqueId);
        formdata.append("SessionId", sessionId);

        if (config.baseUrl) {
            try {
                const data = await requestUtil(
                    `${config.baseUrl}/Messaging/fileuploadwithtracking`,
                    "POST",
                    formdata,
                    null,
                    true
                );
                setFileInputs((prevFileInputs) => {
                    return prevFileInputs.map((input) =>
                        input.id === inputId
                            ? {
                                ...input,
                                file: file,
                                fileName: file ? data?.map((item) => item?.attachedFilename) : "",
                                canTrackId: data?.map((item) => item?.candidateFileTrackingId),
                            }
                            : input
                    );
                });
            } catch (error) {
                toast.error('File Not Valid')
            }
        }
    };

    const generate_uuidv4 = () => {
        var dt = new Date().getTime();
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
            /[xy]/g,
            function (c) {
                var rnd = Math.random() * 16; //random number in range 0 to 16
                rnd = (dt + rnd) % 16 | 0;
                dt = Math.floor(dt / 16);
                return (c === "x" ? rnd : (rnd & 0x3) | 0x8).toString(16);
            }
        );
    };

    const sendEmail = async () => {
        const description = window.descriptionValue();
        if (subject && description) {
            const body = `<p>
            ${description} <br/><br/>
            From: ${data?.fromName} &lt;${data?.messageFrom}&gt; <br/>
            Sent: ${moment().format('LLLL')} <br/>
            To:  ${data?.toName} &lt;${data?.messageTo}&gt;<br/>
            Subject: ${subject}</p><hr/> ${data?.messageBody}`
            const requestBody = {
                candidateUniqueId: candidateUniqueId,
                emailSubject: subject,
                messageBody: body,
                sessionId: sessionId,
                employerUniqueId: login?.employerUniqueId,
                parentId: data?.parentId ? data?.parentId : data?.messageTrackingId,
            };
            try {
                const response = await requestUtil(`${config.baseUrl}/Messaging/send-email-to-candidate`, "POST", { ...requestBody });
                toast.success('Email sent successfully!');
                setFileInputs([]);
                closeModal();
            } catch (error) {
                toast.error(error);
            }
        }
    }

    const subjectVal = (e) => {
        setSubject(e.target.value);
    }


    return (
        <Modal size="xl" show={showModal}>
            <Modal.Header>
                <Modal.Title>Reply</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-sm-12">
                        <form>
                            <Row>
                                <Form.Group as={Col} className="md-6" controlId="From ">
                                    <Form.Label>
                                        From :
                                    </Form.Label>
                                    <span className='ms-2'>{login?.employerSupportEmailFromName}</span>
                                </Form.Group>
                            </Row>
                            <Row>
                                <Form.Group as={Col} className="md-6" controlId="subject">
                                    <Form.Label>
                                        To :
                                    </Form.Label>
                                    <span className='ms-2'>{data?.messageFrom}</span>
                                </Form.Group>
                            </Row>
                            <Row>
                                <Form.Group as={Col} className="md-6" controlId="subject">
                                    <Form.Label>
                                        Subject<span class="required">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Subject"
                                        onChange={(e) => subjectVal(e)}
                                        value={subject}
                                    />
                                </Form.Group>
                            </Row>
                            <Row>
                                <Form.Group as={Col} className="md-6" controlId="email">
                                    <label htmlFor={"summernote"}>Email</label>
                                    <div
                                        id="summernote"
                                        dangerouslySetInnerHTML={{
                                            __html: "",
                                        }}
                                    ></div>
                                </Form.Group>
                            </Row>

                            
                            <div className="d-flex flex-column mt-3 mb-3">
                            <>
                                {fileInputs?.map((input, index) => (
                                    <div key={input.id} className="d-flex gap-3">
                                        {!input.fileName && (
                                            <input
                                                className="mb-3 form-control w-25"
                                                type="file"
                                                onChange={(e) => fileChange(e, input.id)}
                                            />
                                        )}
                                        <div className="col-6 mt-3">
                                            <div className="row" style={{overflowWrap: 'break-word'}}>
                                                {input.fileName && (
                                                    <span
                                                        onClick={() =>
                                                            fileDownloadUploadDoc(
                                                                input?.fileName,
                                                                input?.canTrackId,
                                                                {
                                                                    url: "Messaging/download-candidates-files-tracking-document?",
                                                                }
                                                            )
                                                        }
                                                        style={{ cursor: "pointer" }}
                                                        rel="noreferrer"
                                                        target="_blank"
                                                        className="col-10"
                                                    >
                                                        <i>{input.fileName[0]} -</i>
                                                        <i
                                                            className="mdi mdi-arrange-bring-forward"
                                                            data-bs-toggle="tooltip"
                                                            title=""
                                                            data-bs-original-title="mdi-arrange-bring-forward"
                                                            aria-label="mdi-arrange-bring-forward"
                                                        ></i>
                                                    </span>
                                                )}

                                                <div className="col-1">
                                                    <i
                                                        onClick={() =>
                                                            removeFileInput(input.id, input.canTrackId)
                                                        }
                                                        className="fe fe-trash-2 fa-lg text-danger mt-2 "
                                                        style={{ cursor: "pointer" }}
                                                    ></i>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                ))}
                                <span onClick={addFileInput} className="d-flex">
                                    <i
                                        className="icon-2x icon-plus mt-3 text-info"
                                        data-bs-toggle="tooltip"
                                        title=""
                                        data-bs-original-title="icon-plus"
                                        aria-label="Add Work History"
                                    ></i>
                                    <div
                                        style={{ marginLeft: "0.5rem", cursor: "pointer" }}
                                        className="mt-2 text-info"
                                    >
                                        Add Attachment
                                    </div>
                                </span>
                            </>
                        </div>



                            <Row>
                                <Form.Group>
                                    <>
                                        <span className='ms-2'>From: {`${data?.fromName}<${data?.messageFrom}>`}</span> <br />
                                        <span className='ms-2'>Sent: {moment().format('LLLL')}</span> <br />
                                        <span className='ms-2'>To: {`${data?.toName} <${data?.messageTo}>`}</span> <br />
                                        <span className='ms-2'>Subject: {subject}</span><br />
                                    </>
                                </Form.Group>
                            </Row>
                            <Row>
                                <Form.Group>
                                    <p className='mt-3'
                                        dangerouslySetInnerHTML={{
                                            __html: data?.messageBody
                                            ,
                                        }}
                                    ></p>
                                </Form.Group>
                            </Row>
                        </form>




                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="primary"
                    onClick={() => {
                        sendEmail();
                        setFileInputs([]);
                    }}
                    style={{ display: 'inline-block' }}
                >
                    Send Email
                </Button>
                <button
                    className="btn btn-outline-primary"
                    onClick={() => {
                        closeModal();
                        setFileInputs([]);
                    }}
                >
                    Close
                </button>
            </Modal.Footer>
        </Modal>
    )
}

export default EmailReply